import React from "react"
import { useLanguage } from "../Translations/LenguageContext"
const Brain = () => {
    const {t} = useLanguage()

    return (
        <div className="brain_cont fade-in">
            <h3>{t.architecture.title}</h3>
            <p className="brain_card_desc">{t.architecture.desc}</p>
            <br/>
                <p className="brain_card_desc">{t.architecture.desc2}</p>
        </div >
    )
}

export default Brain